/**
 * --- KONSEP: LAYANAN KEAMANAN (AUTH SERVICE) ---
 * File ini mengurus semua hal yang berkaitan dengan Akun Pengguna,
 * seperti Masuk (Login), Daftar (Register), dan Keluar (Logout).
 */
import { supabase } from '../lib/supabase';

export const authService = {
  /**
   * --- LOGIKA: Masuk Akun ---
   * Memverifikasi apakah Email dan Password yang dimasukkan sudah benar.
   */
  async signIn(email, password) {
    const { data, error } = await supabase.auth.signInWithPassword({
      email,
      password,
    });
    return { data, error };
  },

  /**
   * --- LOGIKA: Daftar Akun Baru ---
   * Membuat akun baru di sistem Supabase. 
   * Metadata digunakan untuk menyimpan Nama Lengkap pengguna.
   */
  async signUp(email, password, metadata = {}) {
    const { data, error } = await supabase.auth.signUp({
      email,
      password,
      options: {
        data: metadata,
      },
    });
    return { data, error };
  },

  /**
   * --- LOGIKA: Keluar Akun ---
   * Menghapus sesi aktif sehingga pengguna harus login lagi jika ingin masuk.
   */
  async signOut() {
    const { error } = await supabase.auth.signOut();
    return { error };
  },

  /**
   * --- LOGIKA: Cek Sesi ---
   * Mengecek apakah ada pengguna yang sedang login saat ini.
   */
  async getSession() {
    const { data: { session }, error } = await supabase.auth.getSession();
    return { session, error };
  },

  /**
   * --- LOGIKA: Pantau Status Login ---
   * Mengawasi jika pengguna tiba-tiba logout atau login kembali.
   */
  onAuthStateChange(callback) {
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      callback(_event, session);
    });
    return subscription;
  },

  /**
   * --- LOGIKA: Lupa Password ---
   * Mengirimkan email pemulihan untuk mengganti kata sandi.
   */
  async resetPassword(email) {
    const { error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: `${window.location.origin}/reset-password`,
    });
    return { error };
  },

  /**
   * --- LOGIKA: Perbaiki Profil ---
   * Menyimpan Nama Lengkap dan Nama Toko bagi yang belum memiliki.
   */
  async updateProfile(userId, full_name, store_name) {
    // 1. Update metadata di auth system
    const { data: userUpdate, error: authError } = await supabase.auth.updateUser({
      data: { full_name, store_name }
    });
    if (authError) return { error: authError };

    // 2. Update data di tabel profiles
    const { error: dbError } = await supabase
      .from('profiles')
      .update({ full_name, store_name })
      .eq('id', userId);
      
    return { error: dbError, data: userUpdate };
  }
};
